import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { userState } from 'app-state/user-state';
import Banner from '../Banner';
import { FormField, makeFormFieldState, validateForm } from '../form-utils/form';
import { FormErrorMessage } from '../form-utils/form-elements';
import Modal from './Modal';

const LoginModal = ({ isOpen, setIsOpen }: {isOpen: boolean, setIsOpen: (isOpen: boolean) => void}) => {
  const [isFormSuccess, setIsFormSuccess] = useState(true);
  const setUserState = useSetRecoilState(userState);
  const form = makeFormFieldState({
    username: { visibleName: 'Username', required: true },
    password: { visibleName: 'Password', required: true },
    tosCheckbox: { visibleName: 'Terms of Service Checkbox', required: true, type: 'boolean' },
  });
  const onSubmit = () => {
    const formValidation = validateForm(form);
    setIsFormSuccess(formValidation);
    if (formValidation && form.password.value?.toLowerCase() === 'letmein') {
      const userName = form.username.value;
      setUserState(userName);
      onClose();
    } else {
      setIsFormSuccess(false);
    }
  };
  const onClose = () => {
    setIsOpen(false);
    form.username.setValue(undefined);
    form.password.setValue(undefined);
    form.tosCheckbox.setBoolean(false);
  };

  return <Modal
    heading="Log In"
    id="login-modal"
    isOpen={isOpen}
    buttons={[
      { text: 'Cancel', onClick: onClose, style: 'grey' },
      { text: 'Log In', onClick: onSubmit, style: 'primary' },
    ]}
  >
    {!isFormSuccess && (
      <div>
        <Banner id='login-warning'>Your login details are incorrect</Banner>
      </div>)}
    <form>
      <div className="mt-5">
        <FormField field={form.username} validateOnChange />
      </div>
      <div className="mt-5">
        <FormField field={form.password} type="password" validateOnChange />
      </div>
      <div className="mt-2 mb-2">
        <div className="inline-flex flex-col w-full p-2 text-left">
          <label className='inline-flex flex-row'>
            <input
              type="checkbox"
              onChange={e => form.tosCheckbox.setBoolean(e.target.checked)}
              id="agree"
              className="mt-2" />
            <span className="ml-2">I agree to the terms of service</span>
          </label>
          {form.tosCheckbox.error && <div><FormErrorMessage>{form.tosCheckbox.error}</FormErrorMessage></div>}
        </div>
      </div>
    </form>
  </Modal>;
};

export default LoginModal;
